<template>
  <!-- middle section here -->
  <section
    class="mothly-view-calc monthly-split-view table-monthly-view redo-header-events"
  >
    <div class="boxes-container">
      <personal-info-vue
        :birthday-needed="birthdayNeeded"
        :show="showPersonalInfo"
        :view="viewPersonalInfo"
        :hide="hidePersonalInfo"
      />

      <!-- Contact info -->
      <div class="heading-appoitment brd-top" @click="toggleContactInfo">
        Contact Info
        <span class="icon-acc-down" :class="{ rotate: showContactInfo }">
          <img src="../../../assets/img/icon-accordion-down.png" alt="Expand" />
        </span>
      </div>
      <transition
        name="expand"
        @before-enter="beforeEnter"
        @after-enter="afterEnter"
        @before-leave="beforeLeave"
        @after-leave="afterLeave"
      >
        <div ref="cust" v-show="showContactInfo">
          <!-- Phones -->
          <phone-vue />

          <!-- Email -->
          <email-vue />

          <!-- Timezone -->
          <timezone-vue />
        </div>
      </transition>

      <div
        @click="toggleInsuranceDetails"
        class="heading-appoitment brd-top"
        v-if="birthdayNeeded && addOrEdit === 'ADD'"
      >
        Insurance Details
        <span class="icon-acc-up" :class="{ rotate: showInsuranceDetails }">
          <img
            src="../../../assets/img/icon-accordion-down.png"
            alt="Collapse"
          />
        </span>
      </div>
      <transition name="expand">
        <div class="cust" v-show="showInsuranceDetails">
          <insurance-vue
            v-if="birthdayNeeded && addOrEdit === 'ADD'"
            :show="showInsuranceDetails"
            :toggle="toggleInsuranceDetails"
          />
        </div>
      </transition>

      <notes :show="showNotes" :view="viewNotes" :hide="hideNotes" />
    </div>
  </section>
  <!-- middle section ends here -->
</template>

<script>
import { addNewHomeMixin } from "../../../mixins/addNewHomeMixin";
import { mapGetters } from "vuex";
import PersonalInfoVue from "./PersonalInfo.vue";
import PhoneVue from "./Phone.vue";
import EmailVue from "./Email.vue";
import TimezoneVue from "./Timezone.vue";
import InsuranceVue from "./Insurance.vue";
import Notes from "./Notes";

export default {
  data() {
    return {
      showPersonalInfo: true,
      showContactInfo: true,
      showInsuranceDetails: false,
      showNotes: true
    };
  },
  mixins: [addNewHomeMixin],
  methods: {
    viewPersonalInfo() {
      this.showPersonalInfo = true;
    },
    hidePersonalInfo() {
      this.showPersonalInfo = false;
    },
    tooglePersonalInfo() {
      this.showPersonalInfo = !this.showPersonalInfo;
    },
    viewContactInfo() {
      this.showContactInfo = true;
    },
    hideContactInfo() {
      this.showContactInfo = false;
    },
    toggleContactInfo() {
      this.showContactInfo = !this.showContactInfo;
    },
    viewInsuranceDetails() {
      this.showInsuranceDetails = true;
    },
    hideInsuranceDetails() {
      this.showInsuranceDetails = false;
    },
    toggleInsuranceDetails() {
      this.showInsuranceDetails = !this.showInsuranceDetails;
    },
    viewNotes() {
      this.showNotes = true;
    },
    hideNotes() {
      this.showNotes = false;
    },
    toggleNotes() {
      this.showNotes = !this.showNotes;
    },
    beforeEnter() {
      this.$refs.cust.classList.add("cust");
    },
    beforeLeave() {
      this.$refs.cust.classList.add("cust");
    },
    afterEnter() {
      this.$refs.cust.classList.remove("cust");
    },
    afterLeave() {
      this.$refs.cust.classList.remove("cust");
    }
  },
  created() {
    if (this.addOrEdit === "ADD") {
      this.clearState();
    }
  },
  computed: {
    ...mapGetters("clients", {
      addOrEdit: "getMode"
    })
  },
  components: {
    PersonalInfoVue,
    PhoneVue,
    EmailVue,
    TimezoneVue,
    InsuranceVue,
    Notes
  },
  props: {
    birthdayNeeded: Boolean
  }
};
</script>

<style scoped>
section {
  margin-top: 108px;
  margin-bottom: 45px;
}

section >>> .border-b-none {
  border-bottom: 0px solid transparent;
}

section >>> .pl-100 {
  padding-left: 100px;
}

section >>> .pl-165 {
  padding-left: 165px;
}

section >>> .dropdown-container select {
  height: 27px;
  margin-top: 4px;
  width: 100%;
  background-color: transparent;
  border: none;
  outline: none;
  padding-right: 30px;
}

section >>> .dropdown-container {
  padding-right: 10px;
  box-sizing: border-box;
}

.expand-enter-active {
  animation: expand 0.3s ease-in-out forwards;
}

.expand-leave-active {
  animation: contract 0.3s ease-in-out forwards;
}

div >>> .rotate {
  transform: rotate(180deg);
}

.cust {
  clear: both;
  overflow: hidden;
}

@keyframes expand {
  from {
    opacity: 0;
    height: 0px;
  }
  to {
    opacity: 1;
    height: 130px;
  }
}

@keyframes contract {
  from {
    opacity: 1;
    max-height: 130px;
  }
  to {
    opacity: 0;
    max-height: 0;
  }
}

@media (max-width: 450px) {
  section {
    margin-top: 99px !important;
    margin-bottom: 45px;
  }
}
</style>
